// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"497":"1dbaf218","753":"34e5cfb3"}[chunkId] + ".css";
};